import { render, staticRenderFns } from "./ColorRuleEditor.vue?vue&type=template&id=67bd6087&scoped=true"
import script from "./ColorRuleEditor.vue?vue&type=script&lang=ts"
export * from "./ColorRuleEditor.vue?vue&type=script&lang=ts"
import style0 from "./ColorRuleEditor.vue?vue&type=style&index=0&id=67bd6087&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bd6087",
  null
  
)

export default component.exports